<span *ngFor='let sep of labelSep; index as i'
      [ngClass]='{"italic": sepValue[i].indexOf("TRANS__") === 0}'>{{sep}}</span>
